module.exports = __webpack_public_path__ + "static/media/Morph2_.a1905e64.png";